import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import EDTabs from '../../../../BaseComponents/Tabs/EDTabs';
import EDTab from '../../../../BaseComponents/Tabs/Tab/EDTab';
import classNames from 'classnames';
import { EDCard } from '../../../../BaseComponents/Card/EDCard';
import { EDCardHeader } from '../../../../BaseComponents/Card/EDCardHeader';
import { EDCardContent } from '../../../../BaseComponents/Card/EDCardContent';
import FunctionMenu from '../../../Delsystem/_Common/Components/FunctionMenu/FunctionMenu/FunctionMenu';
import FunctionItem from '../../../Delsystem/_Common/Components/FunctionMenu/FunctionItem/FunctionItem';

interface IProps {
  title?: string;
  subtitle?: string;
  showTabs: boolean;
  activeTab: number;
  onTabChange: (tab: number) => void;
  classes?: any;
}

const styles = (theme: Theme) => ({
  header: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(1),
  },
  subheader: {
    height: '40px',
    overflow: 'auto',
    color: theme.customProperties.Fade.DarkOnLight.highEmphasis,
    fontWeight: 400,
  },
  childContainer: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingBottom: theme.spacing(4),
    display: 'flex',
    flex: '1 1 auto',
    justifyContent: 'center',
  },
  tabsContainer: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  tabsHidden: {
    visibility: 'hidden',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tabs: {
    color: theme.customProperties.Fade.DarkOnLight.mediumEmphasis,
  },
});

/**
 * Container komponent för ProcessActivity i processträdet
 */
export const ActivityPanel: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDCard height="560px">
      <EDCardHeader
        className={props.classes.header}
        title={
          <div className={props.classes.title}>
            <div>{props.title}</div>
            <FunctionMenu id="processAktivitet">
              <FunctionItem iconType="help_outline">Hjälp</FunctionItem>
              <FunctionItem iconType="exit_to_app">Gå till rutin</FunctionItem>
            </FunctionMenu>
          </div>
        }
        subheader={props.subtitle}
        classes={{ subheader: props.classes.subheader }}
      />
      <EDCardContent>{props.children}</EDCardContent>
      <div className={props.classes.tabsContainer}>
        <EDTabs
          value={props.activeTab}
          onChange={props.onTabChange}
          variant="fullWidth"
          className={classNames(
            { [props.classes.tabsHidden]: !props.showTabs },
            props.classes.tabs
          )}
        >
          <EDTab
            textColor="inherit"
            label="Process"
            icon={<EDIcon iconType="process" />}
          />
          <EDTab
            textColor="inherit"
            label="Statistik"
            icon={<EDIcon iconType="insert_chart" />}
          />
          <EDTab
            textColor="inherit"
            label="HUKI"
            icon={<EDIcon iconType="people" />}
          />
        </EDTabs>
      </div>
    </EDCard>
  );
};

export default withStyles(ActivityPanel, styles);
